import React, { useState, useEffect } from "react";
import * as S from "./IntegrationsStyle";

export default function Integrations() {
  const [isConnected, setIsConnected] = useState(false);

  const baseUrl = "https://auth.contaazul.com/login";
  const params = new URLSearchParams({
    response_type: "code",
    client_id: "1reddu98bilq4alolfkffg0jbe",
    redirect_uri: "https://0938-177-191-207-224.ngrok-free.app/api/contaazul/callback",
    scope: "openid profile aws.cognito.signin.user.admin",
    state: "123"
  });

  const CONTA_AZUL_URL = `${baseUrl}?${params.toString()}`;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("success") === "true") {
      setIsConnected(true);
    }
  }, []);

  return (
    <S.Container>
      <S.ContentCard>
        <S.Title>Integrações Externas</S.Title>
        <S.Description>
          Conecte sua plataforma a serviços externos para automatizar processos
          financeiros e de cadastro.
        </S.Description>
        <S.IntegrationBox>
          <img src="/conta-azul-logo.png" alt="Conta Azul" />
          <p style={{ marginBottom: "20px", color: "#444" }}>
            Sincronize automaticamente seus pagamentos e cadastros de clientes
            com o ERP Conta Azul.
          </p>
          <S.ConnectButton href={CONTA_AZUL_URL}>
            {isConnected ? "RECONECTAR CONTA" : "CONECTAR CONTA AZUL"}
          </S.ConnectButton>
          <S.StatusTag connected={isConnected}>
            {isConnected ? "Sincronizado" : "Não conectado"}
          </S.StatusTag>
        </S.IntegrationBox>
      </S.ContentCard>
    </S.Container>
  );
}